import { CLS } from "../constants";

const SectionTitle = ({
  icon,
  children,
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) => (
  <h3 className={CLS.sectionTitle}>
    {icon}
    {children}
  </h3>
);

export default SectionTitle;